export const NOTIFICATION_TYPES = {
  EVENT_REMINDERS: 'event_reminders',
  TASK_REMINDERS: 'task_reminders',
  TAG_OFFLINE: 'tag_offline',
  GATEWAY_OFFLINE: 'gateway_offline',
  MEDIUM_PRIORITY_RULES: 'medium_priority_rules',
  HIGH_PRIORITY_RULES: 'high_priority_rules'
};
